// extracted by mini-css-extract-plugin
export default {"container":"success_container__ruvEV","backgroundContainer":"success_backgroundContainer__ZJSub","divHome":"success_divHome__INu5X"};